export const box = { 
    display:'flex', 
    flexDirection:'column'
}
export const typo = {
    fontWeight: '500', 
    mb: '8px'
}
export const typogra = {
    fontWeight: '500', 
    mb: '8px', 
    mt: '16px'
}
export const button = {
    mt:'40px'
}